'use strict';

angular.module('ClinicApp').directive('availabilityCalendar', function() {
  return {
    templateUrl: '/views/directives/_availability-calendar.html',
    scope: {
      blockPicked: '=',
      getBlockClass: '=',
      startWeek: '=',
    },
    link: function($scope) {

      $scope.date = {
        min: moment().startOf('week'),
        max: moment().startOf('week')
          .add(1, 'years')
          .startOf('week'),
        currentWeek: $scope.startWeek,
      };

      $scope.calendarBackward = function() {
        $scope.date.currentWeek.subtract(7, 'days');
      };

      $scope.calendarForward = function() {
        $scope.date.currentWeek.add(7, 'days');
      };

      $scope.getChangedDay = function(m, length) {
        return moment(m).add(length, 'days')
          .toDate();
      };

    },
  };
});
